<template>
  <PhoneResolver
    ref="phoneResolver"
    :phoneNumber="fullPhoneNumber"
    @carrier="
      val => {
        this.$emit('operatorDetected', val)
      }
    "
    ><div></div>
  </PhoneResolver>
</template>

<script>
import { defineComponent } from 'vue'
import PhoneResolver from '../../utils/PhoneResolver.vue'

export default defineComponent({
  name: 'PhoneOperatorDetector',
  components: { PhoneResolver },
  props: {
    fullPhoneNumber: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      htmlValue: '',
      eventsIds: [],
      operators: {},
      operator: '',
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.$refs.phoneResolver?.resolve(this.fullPhoneNumber);
    // }, 500);
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    scheduleOperatorDetection() {
      this.resetOperators()
    },

    field(propertyName) {
      return this.formFields.findIndex(el => el.propertyName == propertyName)
    },
    makeLoading() {
      if (!this.loadSavedOperator()) {
        this.htmlValue = `<div class="shimmerElement"><img class="shimmerElement w-[60px] h-[30px] -mt-2 object-cover object-center" src=""></di>`
      }
    },
    loadSavedOperator() {
      let phoneCountry = this.countryCode

      if (!this.$Commons.isEmpty(this.operators[`${this.amount}`])) {
        this.htmlValue =
          `<span class="text-red-500 text-sm font-bold"> Frais: ` +
          this.operators[`${phoneCountry}${this.amount}`] +
          ' CFA </span>'
        return true
      }
    },
    async resetOperators() {
      this.$refs.phoneResolver?.resolve(this.fullPhoneNumber)
    },
    async resolve(...args) {
      this.$refs.phoneResolver?.resolve(...args)
    },
  },
  watch: {},
})
</script>
